{
  "version": 1,
  "asset_id": "22c4682e-ec05-442b-b0c3-08cd49507f6f",
  "project_id": "e1a64cc6-0fc8-4a5b-9036-8fa01cc3f811",
  "url": "/__l5e/assets-v1/22c4682e-ec05-442b-b0c3-08cd49507f6f/service-gutter-guards.webp",
  "r2_key": "a/v1/e1a64cc6-0fc8-4a5b-9036-8fa01cc3f811/22c4682e-ec05-442b-b0c3-08cd49507f6f/service-gutter-guards.webp",
  "original_filename": "service-gutter-guards.webp",
  "size": 203460,
  "content_type": "image/webp",
  "created_at": "2026-08-01T22:43:21Z"
}
